/* 🤖 this file was generated by svg-to-ts */
export const matIconQrCode: {
  name: 'qr-code';
  data: string;
} = {
  name: 'qr-code',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm8-12v8h8V3h-8zm6 6h-4V5h4v4zm0 10h2v2h-2zm-6-6h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zm2 2h2v2h-2zm2-2h2v2h-2zm0-4h2v2h-2zm2 2h2v2h-2z"/></svg>`
};
